import { render, staticRenderFns } from "./CheatSection.vue?vue&type=template&id=529f641e&scoped=true&"
import script from "./CheatSection.vue?vue&type=script&lang=js&"
export * from "./CheatSection.vue?vue&type=script&lang=js&"
import style0 from "./CheatSection.vue?vue&type=style&index=0&id=529f641e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529f641e",
  null
  
)

export default component.exports